import { render, staticRenderFns } from "./Equipo_Planta.vue?vue&type=template&id=706d7fb3&scoped=true&"
import script from "./Equipo_Planta.vue?vue&type=script&lang=js&"
export * from "./Equipo_Planta.vue?vue&type=script&lang=js&"
import style0 from "./Equipo_Planta.vue?vue&type=style&index=0&id=706d7fb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706d7fb3",
  null
  
)

export default component.exports